import { Link } from "react-router-dom";

const steps = [
  {
    no: "01",
    title: "先看《守护甜心！》",
    desc: "第一季 51 集，从亚梦的守护蛋孵化开始，建立守护者与复活社的世界观。",
    link: "/episodes",
    tone: "text-primary-600 bg-primary-100",
  },
  {
    no: "02",
    title: "再补《守护甜心！！心跳》",
    desc: "第二季 51 集，主线冲突升级，三角关系、几斗身世与守护蛋的考验层层展开。",
    link: "/episodes",
    tone: "text-secondary-700 bg-secondary-100",
  },
  {
    no: "03",
    title: "收尾《守护甜心！派对》",
    desc: "第三季 25 集，以动画与真人结合的形式温暖收尾，为系列画上句点。",
    link: "/episodes",
    tone: "text-accent-800 bg-accent-100",
  },
  {
    no: "04",
    title: "边看边对照剧情速览",
    desc: "每一集都有简明剧情速览，随时点开对照进度，告别反复回看的烦恼。",
    link: "/analysis",
    tone: "text-primary-600 bg-primary-100",
  },
];

export default function ViewingGuide() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-sm text-primary-600 font-medium">观看指南</p>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
              守护甜心怎么补最顺畅？
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
                守护甜心系列共三部、约 127 集。新手按下面的顺序补番，剧情衔接最自然；老观众也能通过速览快速定位想重温的片段。
              </p>
            <Link
              to="/episodes"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 whitespace-nowrap hover:bg-primary-600"
            >
              开始看分集剧情
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <ol className="space-y-4">
            {steps.map((s) => (
              <li
                key={s.no}
                className="flex gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-5"
              >
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-display text-lg ${s.tone}`}>
                  {s.no}
                </span>
                <div>
                  <h3 className="font-medium text-foreground-950">{s.title}</h3>
                  <p className="mt-1 text-sm leading-6 text-foreground-700">{s.desc}</p>
                  <Link to={s.link} className="mt-2 inline-flex items-center gap-1 text-sm text-primary-600">
                    相关剧情 <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}